module.exports = __webpack_public_path__ + "static/media/technology.aea11377.png";